import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { getUser } from 'store/actions/user';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'components';
import useAuthentication from 'utils/useAuthentication';
import { useMatomo } from '@jonkoops/matomo-tracker-react';

const isServer = typeof window === 'undefined';

const AuthGuard = ({ children }) => {
    const router = useRouter();
    const interval = useRef(null);
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const matomo = useMatomo();

    const { authenticated, initialized, login, updateToken } = useAuthentication();

    useEffect(() => {
        if (initialized && authenticated) {
            updateToken(-1);
            dispatch(getUser());
            interval.current = setInterval(() => updateToken(), 10 * 1000);
        }
        if (!authenticated) clearInterval(interval.current);
    }, [dispatch, authenticated, initialized, updateToken]);

    useEffect(() => {
        if (user.userId) matomo.pushInstruction('setUserId', user.userId);
        matomo.trackPageView();
    }, [matomo, user.userId]);

    const isProtected = router.pathname.startsWith('/mit-penly');

    if (!isServer && isProtected && initialized && !authenticated) {
        login({ redirectPath: window.location.pathname });
        return null;
    }

    if (isProtected && !user.userId) return <Loader show={ true } />;

    return <>{ children }</>;
};

AuthGuard.propTypes = { children: PropTypes.node.isRequired };

export default AuthGuard;
